import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles(theme => ({
  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },
}));

const ShibbolethAuthenticationCell = props => {
  const { authentication } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <Box className={classes.labelAndValue}>
          <label>Shibboleth Value:</label>
          {authentication.shibbolethValue}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ShibbolethAuthenticationCell;
